/* eslint-disable */
import PropTypes from 'prop-types';

export const modalActionsPropTypes = PropTypes.shape({
    close: PropTypes.func,
    constructAction: PropTypes.func,
    open: PropTypes.func,
});
